"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowWrapper = exports.ExtraWrapper = exports.DraggableWrapper = exports.DragIcon = exports.ContentWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _breakpoints = _interopRequireDefault(require("../../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DraggableWrapper = exports.DraggableWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "erm9r2v4"
} : {
  target: "erm9r2v4",
  label: "DraggableWrapper"
})("grid-row-gap:1em;background-color:#ffffff;align-content:center;align-items:center;@media screen and (max-width: ", _breakpoints.default.medium, "){grid-column-gap:1em;}");
const ContentWrapper = exports.ContentWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "erm9r2v3"
} : {
  target: "erm9r2v3",
  label: "ContentWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1111ted",
  styles: "display:grid;grid-auto-flow:column;align-content:center;align-items:center"
} : {
  name: "1111ted",
  styles: "display:grid;grid-auto-flow:column;align-content:center;align-items:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const RowWrapper = exports.RowWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "erm9r2v2"
} : {
  target: "erm9r2v2",
  label: "RowWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "gkap3s",
  styles: "display:grid;grid-template-columns:15px 2fr;grid-column-gap:2em;grid-column:2;align-items:center"
} : {
  name: "gkap3s",
  styles: "display:grid;grid-template-columns:15px 2fr;grid-column-gap:2em;grid-column:2;align-items:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const ExtraWrapper = exports.ExtraWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "erm9r2v1"
} : {
  target: "erm9r2v1",
  label: "ExtraWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1twzs4g",
  styles: "margin-left:calc(15px + 2em);padding-bottom:1em"
} : {
  name: "1twzs4g",
  styles: "margin-left:calc(15px + 2em);padding-bottom:1em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const DragIcon = exports.DragIcon = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "erm9r2v0"
} : {
  target: "erm9r2v0",
  label: "DragIcon"
})();